import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import styles from './StreamKeysCancel.module.scss';

const StreamKeysCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleTryAgain = (): void => {
    navigate('/stream-keys');
  };

  const handleGoToProjects = (): void => {
    navigate('/projects');
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <CancelIcon className={styles.cancelIcon} />
        <Typography variant="h4" className={styles.title}>
          Purchase Cancelled
        </Typography>
        <Typography variant="body1" className={styles.message}>
          Your stream key purchase was cancelled. No charges have been made to your account.
        </Typography>
        <Box className={styles.buttonContainer}>
          <Button variant="contained" onClick={handleTryAgain} className={styles.button}>
            Try Again
          </Button>
          <Button variant="outlined" onClick={handleGoToProjects} className={styles.button}>
            Go to Projects
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StreamKeysCancel;
